var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerationalMatchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.374,
    height: 50.289,
    viewBox: "0 0 53.374 50.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-svgrepo-com_1_",
    "data-name": "team-svgrepo-com (1)",
    transform: "translate(0 -14.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(21.899 14.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M214.856,14.8a4.788,4.788,0,1,0,4.788,4.788A4.794,4.794,0,0,0,214.856,14.8Z",
    transform: "translate(-210.068 -14.798)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(18.85 24.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M196.4,119.753l-2.032-6.1a1.74,1.74,0,0,0-1.651-1.19h-8.128a1.74,1.74,0,0,0-1.651,1.19l-2.032,6.1a1.741,1.741,0,0,0,1.651,2.291h12.191A1.741,1.741,0,0,0,196.4,119.753Z",
    transform: "translate(-180.82 -112.467)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(3.049 30.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M34.035,161.234a4.788,4.788,0,1,0,4.788,4.788A4.794,4.794,0,0,0,34.035,161.234Z",
    transform: "translate(-29.247 -161.234)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0 40.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M15.584,266.19l-2.032-6.1A1.74,1.74,0,0,0,11.9,258.9H3.773a1.74,1.74,0,0,0-1.651,1.19l-2.032,6.1a1.741,1.741,0,0,0,1.651,2.291H13.933A1.741,1.741,0,0,0,15.584,266.19Z",
    transform: "translate(0 -258.904)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(21.899 45.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M214.857,307.672a4.788,4.788,0,1,0,4.788,4.788A4.794,4.794,0,0,0,214.857,307.672Z",
    transform: "translate(-210.069 -307.672)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(18.85 55.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M196.4,412.625l-2.032-6.1a1.74,1.74,0,0,0-1.651-1.19h-8.128a1.74,1.74,0,0,0-1.651,1.19l-2.032,6.1a1.741,1.741,0,0,0,1.651,2.291h12.191A1.741,1.741,0,0,0,196.4,412.625Z",
    transform: "translate(-180.821 -405.339)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(9.978 20.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M105.516,71.72a1.74,1.74,0,0,0-2.324-.81,21.462,21.462,0,0,0-7.068,5.514,1.74,1.74,0,0,0,2.67,2.233,17.955,17.955,0,0,1,5.913-4.614A1.74,1.74,0,0,0,105.516,71.72Z",
    transform: "translate(-95.718 -70.736)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(40.749 30.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M395.676,161.235a4.788,4.788,0,1,0,4.788,4.788A4.794,4.794,0,0,0,395.676,161.235Z",
    transform: "translate(-390.888 -161.235)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(37.7 40.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M377.226,266.189l-2.032-6.1a1.74,1.74,0,0,0-1.651-1.19h-8.127a1.74,1.74,0,0,0-1.651,1.19l-2.032,6.1a1.741,1.741,0,0,0,1.651,2.291h12.191A1.741,1.741,0,0,0,377.226,266.189Z",
    transform: "translate(-361.642 -258.903)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(33.424 20.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M330.193,76.426a21.463,21.463,0,0,0-7.068-5.514,1.74,1.74,0,1,0-1.515,3.134,17.955,17.955,0,0,1,5.913,4.614,1.74,1.74,0,1,0,2.67-2.233Z",
    transform: "translate(-320.627 -70.738)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(33.424 50.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M329.974,359.7a1.74,1.74,0,0,0-2.452.218,17.955,17.955,0,0,1-5.913,4.614,1.74,1.74,0,0,0,1.515,3.134,21.462,21.462,0,0,0,7.068-5.514A1.741,1.741,0,0,0,329.974,359.7Z",
    transform: "translate(-320.627 -359.292)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(9.978 50.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M104.707,364.529a17.956,17.956,0,0,1-5.913-4.614,1.74,1.74,0,1,0-2.67,2.233,21.463,21.463,0,0,0,7.068,5.514,1.74,1.74,0,1,0,1.515-3.134Z",
    transform: "translate(-95.719 -359.291)",
    fill: "#3d3d3d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerationalMatchIcon);
export default __webpack_public_path__ + "static/media/generational-match-icon.efb97924f2cdc0b3d4a4e0674fc44137.svg";
export { ForwardRef as ReactComponent };